import { Input, Select, useSnackbar } from '@components/common';
import { Col, Container, Row, media } from 'styled-bootstrap-grid';
import styled from 'styled-components';
import { useEffect, useState } from 'react';
import useRouter from 'hooks/router';
import moment from 'moment';
import { palette } from 'styled/common';
import DeleteModel from '../DeleteModel/DeleteModel';
import { api } from 'helpers/auth-axios';
import { ISpecialWorkingHours } from 'interfaces/specialHours.interface';
import { roundTimeDownToNext15Minutes } from '../utils';

const SpecialWorkingHours = ({
    serviceProviderId,
    readOnly,
}: {
    serviceProviderId: string; // ID of the user we're looking up working hours for
    readOnly?: boolean;
}) => {
    const [openSnackbar] = useSnackbar();
    const [deleteModel, setDeleteModel] = useState(false);
    const [loading, setLoading] = useState(false);
    const [itemToDelete, setItemToDelete] = useState<ISpecialWorkingHours>();
    const router = useRouter();
    const [specialHoursList, setSpecialHoursList] = useState<ISpecialWorkingHours[]>([]);
    const [specHoursDate, setSpecHoursDate] = useState<string>(moment().format('YYYY-MM-DD'));
    const [specHoursFrom, setSpecHoursFrom] = useState<string>(
        roundTimeDownToNext15Minutes(moment().format('HH:mm'))
    );
    const [specHoursTill, setSpecHoursTill] = useState<string>(
        roundTimeDownToNext15Minutes(moment().format('HH:mm'))
    );

    var _userData = JSON.parse(localStorage.getItem('user') || '{}');
    var timezone = _userData.user.business_id.timezone;

    let hoursOptions: { label: string; value: any }[] = [];
    for (let i: any = 0; i < 24; i++) {
        for (let j = 0; j < 60; j += 15) {
            hoursOptions.push({
                label: moment({
                    hour: i,
                    minute: j,
                }).format(_userData.user.business_id.time_select === '12' ? 'hh:mm a' : 'HH:mm'),
                value: moment({ hour: i, minute: j }).format('HH:mm'),
            });
        }
    }

    const onSubmit = () => {
        const fromDateTime: moment.Moment = moment.tz(
            `${specHoursDate} ${specHoursFrom}`,
            'YYYY-MM-DD HH:mm',
            timezone
        );
        const tillDateTime: moment.Moment = moment.tz(
            `${specHoursDate} ${specHoursTill}`,
            'YYYY-MM-DD HH:mm',
            timezone
        );
        console.log(`fromDateTime="${fromDateTime}" ; tillDateTime="${tillDateTime}"`);
        const payload = {
            serviceProviderId: serviceProviderId,
            fromDateTime: fromDateTime,
            tillDateTime: tillDateTime,
        };
        api.post(`/special-hours`, payload)
            .then((res: any) => {
                refreshSpecialHoursList();
                openSnackbar('Special hours saved successfully!');
            })
            .catch((e: any) => {
                if (e?.response) {
                    openSnackbar(e?.response?.data?.message);
                }
            });
    };

    const refreshSpecialHoursList = () => {
        api.get(`/special-hours/${serviceProviderId}`)
            .then((res: any) => {
                setSpecialHoursList(res.data);
            })
            .catch((e: any) => {
                if (e?.response) {
                    openSnackbar(e?.response?.data?.message);
                }
            });
    };

    useEffect(() => {
        // Perform initial fetch of special working hours
        refreshSpecialHoursList();
    }, [serviceProviderId]);

    const openDeleteModel = (specHoursToDelete: ISpecialWorkingHours) => {
        setDeleteModel(true);
        setItemToDelete(specHoursToDelete);
    };

    const deleteSpecialHours = (specHoursId: string | undefined) => {
        if (!specHoursId) return;

        api.delete(`/special-hours/${serviceProviderId}/${specHoursId}`)
            .then((res: any) => {
                refreshSpecialHoursList();
                openSnackbar('Removed special hours successfully!');
                setDeleteModel(false);
            })
            .catch((e: any) => {
                if (e?.response) {
                    openSnackbar(e?.response?.data?.message);
                }
                setDeleteModel(false);
            });
    };

    return (
        <Container style={{ padding: '0px' }}>
            <Row>
                <Col lg={12}>
                    {!readOnly && (
                        <div>
                            <Container>
                                <Row style={{ marginBottom: '10px', marginTop: '10px' }}>
                                    <Col lg={12}>
                                        <h3>Add Special Hours</h3>
                                    </Col>
                                </Row>
                                <Row>
                                    <Flex xs={10} sm={10} md={10} lg={10} xl={4}>
                                        <Input
                                            label="date"
                                            type="date"
                                            name="date"
                                            min={new Date().toISOString().split('T')[0]}
                                            value={specHoursDate}
                                            onChange={({
                                                name,
                                                value,
                                            }: {
                                                name: string;
                                                value: string;
                                            }) => {
                                                setSpecHoursDate(value);
                                            }}
                                            //error={errors.from_iso as any}
                                        />
                                    </Flex>
                                    <Flex xs={5} sm={5} md={5} lg={5} xl={3}>
                                        <Select
                                            options={hoursOptions}
                                            label="from"
                                            name="from"
                                            value={moment(
                                                specHoursDate + ' ' + specHoursFrom,
                                                'YYYY-MM-DD HH:mm:ss'
                                            ).format(
                                                _userData.user.business_id.time_select === '12'
                                                    ? 'hh:mm a'
                                                    : 'HH:mm'
                                            )}
                                            onChange={(val: string) => setSpecHoursFrom(val)}
                                        />
                                    </Flex>
                                    <Flex xs={5} sm={5} md={5} lg={5} xl={3}>
                                        <Select
                                            options={hoursOptions}
                                            label="till"
                                            name="till"
                                            value={moment(
                                                specHoursDate + ' ' + specHoursTill,
                                                'YYYY-MM-DD HH:mm:ss'
                                            ).format(
                                                _userData.user.business_id.time_select === '12'
                                                    ? 'hh:mm a'
                                                    : 'HH:mm'
                                            )}
                                            onChange={(val: string) => setSpecHoursTill(val)}
                                        />
                                    </Flex>
                                    <FlexEnd xs={2} sm={2} md={2} lg={2} xl={2}>
                                        <AddIcon type="submit" onClick={onSubmit}>
                                            <i className="fal fa-plus"></i>
                                        </AddIcon>
                                    </FlexEnd>
                                </Row>
                            </Container>
                        </div>
                    )}
                    <CustomCol lg={12}>
                        <div key={0}>
                            <Container key={0} style={{ marginBottom: '0.5rem' }}>
                                <Row>
                                    <FlexStart xs={3} sm={3} md={3} lg={3} xl={3}>
                                        Date
                                    </FlexStart>
                                    <FlexStart xs={3} sm={3} md={3} lg={3} xl={3}>
                                        From
                                    </FlexStart>
                                    <FlexStart xs={3} sm={3} md={3} lg={3} xl={3}>
                                        To
                                    </FlexStart>
                                    {!readOnly && (
                                        <FlexCenter xs={2} sm={2} md={2} lg={2} xl={3}></FlexCenter>
                                    )}
                                </Row>
                            </Container>
                        </div>
                        {specialHoursList !== undefined &&
                            specialHoursList.map((specHours: ISpecialWorkingHours, i: any) => (
                                <div key={i + 1}>
                                    <Container key={i + 1} style={{ marginBottom: '0.5rem' }}>
                                        <Row>
                                            <FlexStart xs={3} sm={3} md={3} lg={3} xl={3}>
                                                <b>
                                                    {specHours.fromDateTime
                                                        ? moment(specHours.fromDateTime).format(
                                                              'MM/DD/YYYY'
                                                          )
                                                        : 'No Special Hours'}{' '}
                                                </b>
                                            </FlexStart>
                                            <FlexStart xs={3} sm={3} md={3} lg={3} xl={3}>
                                                <b>
                                                    {specHours.fromDateTime
                                                        ? moment(specHours.fromDateTime).format(
                                                              'h:mm a'
                                                          )
                                                        : 'No Special Hours'}{' '}
                                                </b>
                                            </FlexStart>
                                            <FlexStart xs={3} sm={3} md={3} lg={3} xl={3}>
                                                <b>
                                                    {specHours.tillDateTime
                                                        ? moment(specHours.tillDateTime).format(
                                                              'h:mm a'
                                                          )
                                                        : 'No Special Hours'}
                                                </b>
                                            </FlexStart>
                                            {!readOnly && (
                                                <FlexCenter xs={2} sm={2} md={2} lg={2} xl={3}>
                                                    <DeleteIcon
                                                        onClick={() => openDeleteModel(specHours)}>
                                                        <i className="fal fa-trash-alt"></i>
                                                    </DeleteIcon>
                                                </FlexCenter>
                                            )}
                                        </Row>
                                    </Container>
                                </div>
                            ))}
                    </CustomCol>
                    {deleteModel && (
                        <DeleteModel
                            onDelete={() => {
                                setDeleteModel(false);
                            }}
                            name="Special Hours"
                            content={`Are you sure you want to delete the special hours on ${moment(
                                itemToDelete?.fromDateTime
                            ).format('MMM D YYYY')} from ${moment(
                                itemToDelete?.fromDateTime
                            ).format('h:mm a')} to ${moment(itemToDelete?.tillDateTime).format(
                                'h:mm a'
                            )}?`}
                            loading={loading}
                            onClick={() => deleteSpecialHours(itemToDelete?._id)}
                            onClose={() => {
                                setDeleteModel(false);
                            }}
                        />
                    )}
                </Col>
            </Row>
        </Container>
    );
};

const Wrapper = styled(Container)``;
const AddIcon = styled.button`
    width: 50px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 1rem 1.71rem 0 rgb(0 0 0 / 28%);
    background: #0154ff;
    border-radius: 100%;
    color: #fff;
    font-size: 1.5rem;
    border: none;
    cursor: pointer;
`;
const List = styled.div`
    display: flex;
    justify-content: space-around;
    margin-top: 0.4rem;
    padding-top: 1rem;
    border-top: 1px solid #e5e7eb;
`;
const CustomDiv = styled.div`
    margin-left: 1rem;
`;
const DeleteIcon = styled.button`
    padding: 0;
    width: 1.85rem;
    height: 1.85rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-width: 0rem;
    background-color: ${palette.primary};
    color: ${palette.light};
    font-weight: 600;
    text-transform: capitalize;
    border-radius: 0.51rem;
    font-size: 0.87rem;
    cursor: pointer;
`;
const CustomCol = styled(Col)`
    padding: 0;
    margin-top: 1rem;
`;
const Flex = styled(Col)`
    display: flex;
    justify-content: end;
    align-items: center;
    margin-bottom: 0rem;
    ${media.xs`
    justify-content: start;
    margin-bottom:1rem;
	`}
    ${media.sm`
    justify-content: end;
	`}
	${media.md`
    justify-content: end;
	`}
	${media.lg`
    justify-content: end;
	`}
    @media screen and (min-width: 200px) and (max-width: 1050px) {
        padding-right: 0rem;
    }
`;
const FlexStart = styled(Col)`
    display: flex;
    white-space: nowrap;
    justify-content: start;
    align-items: center;
`;
const FlexCenter = styled(Col)`
    display: flex;
    white-space: nowrap;
    justify-content: center;
    align-items: center;
`;
const FlexEnd = styled(Col)`
    display: flex;
    white-space: nowrap;
    justify-content: end;
    align-items: center;
`;
export default SpecialWorkingHours;
